import React from "react";
import "./HomeTestimonials.scss";
import QuoteCarousel from "../QuoteCarousel/QuoteCarousel";
import { QuoteCarouselContents } from "../QuoteCarousel/quoteCarouselContents";

export default function HomeTestimonials() {
  return (
    <div className="homepage__testimonials">
      <section className="testimonials__top">
        <h2 className="testimonials__header">Testimonials</h2>
        <hr className="testimonials__line" />
      </section>
      <QuoteCarousel items={QuoteCarouselContents} />
    </div>
  );
}
